import { useContext } from "react";

import { DataContext, DataContextType } from "./Data";

export default function useData() {
	return useContext(DataContext) as DataContextType;
}
